// extracted by mini-css-extract-plugin
export default {"dealBox":"Deal_dealBox__Wyn5D","imageBox":"Deal_imageBox__kJYoC","img":"Deal_img__oc1xI","avatar":"Deal_avatar__fnZ4U","editButton":"Deal_editButton__l8Wk5"};